export const pluginInstallModal = {
  mainBox: {
    width: { xs: '100%', sm: 'min-content' },
    minWidth: { xs: '100%', sm: '32rem' },
    marginTop: '-35px'
  },
  installPluginTitle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)',
    marginBottom: '8px'
  },
  installPluginDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    marginBottom: '44px',
    maxWidth: '77%',
    marginLeft: 'auto',
    marginRight: 'auto',
    color: 'var(--color-text-tertiary)'
  },
  imgPlugin: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '24px',
    maxWidth: '100%',
    maxHeight: '100%',
    height: 'auto',
    width: 'auto',
    minWidth: '48%'
  },
  installPluginBtnBox: {
    textAlign: 'center',
    marginBottom: '24px'
  },
  installPluginBtn: {
    height: '24px',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiButton-endIcon': {
      marginLeft: '0px !important'
    },
    color: 'var(--color-primary)'
  },
  northIcon: {
    marginLeft: '-6px'
  },
  installPluginBtnTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 800,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-primary)'
  }
};

export const scanInfoSx = {
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center', // This will center the text content
    gap: 2 // Adds space between the items
  },
  scanWebPage: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-heading)',
    marginTop: '5px'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-mid)',
    maxWidth: '950px',
    marginTop: '7px',
    marginBottom: '15px'
  },
  img: {
    width: '100%',
    maxWidth: '1000px'
  },
  tutorialBox: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginTop: '11px'
  },
  watchTutorialText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 800,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  }
};

export const newCommonChromeExtensionModalSx = {
  mainBox: {
    border: '1px solid var(--color-secondary)',
    backgroundColor: 'var(--color-success-bg-ultra)',
    gap: { xs: '10px', sm: '16px' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    borderRadius: '8px',
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    marginBottom: '1rem',
    padding: { xs: '0.75rem', sm: '0.5rem' }
  },
  headerText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 800,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginBottom: '4px'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  }
};

export const scanListViewSx = {
  searchBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px'
  },
  scannedUrlSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    marginBottom: '15px'
  },
  scannedUrlBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  greenBannerBoxSx: {
    marginBottom: '0px'
    //maxWidth: '18rem',
    // marginLeft: 'auto'
  }
};
